import {
  LooksOneRounded,
  LooksOneTwoTone,
  LooksTwoRounded,
  Looks3Rounded,
  Looks4Rounded,
  Looks5Rounded,
  Looks6Rounded,
  SvgIconComponent,
} from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

interface Props {
  title: string
  Icon: SvgIconComponent
  link: string
}
function SidebarItem ({ title, Icon, link }: Props) {
  const { pathname } = useLocation()

  return (
    <Link
      to={link}
      className={classNames(
        'flex flex-col items-center gap-2 p-8 hover:bg-blue-200 transition-colors',
        { 'bg-blue-100': pathname === `/${link}` },
      )}
    >
      <Icon className="!w-[3.2rem] !h-[3.2rem]" />
      <Typography
        fontSize="0.8rem"
        fontFamily="Roboto"
        textAlign="center"
        lineHeight={1.2}
        whiteSpace="nowrap"
      >
        {title}
      </Typography>
    </Link>
  )
}

function Sidebar () {
  const { t } = useTranslation()

  return (
    <Box className="flex flex-col bg-gray-50 z-10" boxShadow="0.1rem 0 0 rgba(0, 0, 0, 0.1)">
      <SidebarItem
        title={t('GLOSSARY.ONE_WAY_SLAB')}
        link="one-way-slab"
        Icon={LooksOneRounded}
      />
      <SidebarItem
        title={t('GLOSSARY.TWO_WAY_SLAB')}
        link="two-way-slab"
        Icon={LooksOneTwoTone}
      />
      <SidebarItem
        title={t('GLOSSARY.BEAM')}
        link="beam"
        Icon={LooksTwoRounded}
      />
      <SidebarItem
        title={t('GLOSSARY.COLUMN')}
        link="column"
        Icon={Looks3Rounded}
      />
      <SidebarItem
        title={t('GLOSSARY.FOUNDATION')}
        link="foundation"
        Icon={Looks4Rounded}
      />
      <SidebarItem
        title={t('GLOSSARY.BASEMENT_WALL')}
        link="basement-wall"
        Icon={Looks5Rounded}
      />
      <SidebarItem
        title={t('GLOSSARY.WIND_TUNNEL_STUDY')}
        link="wind-tunnel-study"
        Icon={Looks6Rounded}
      />
    </Box>
  )
}

export default Sidebar
